var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{ref:"tenant",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disabled,"options":_vm.regionList,"props":_vm.regionProps,"placeholder":_vm.placeholder,"clearable":_vm.clearable},on:{"change":_vm.change},model:{value:(_vm.tenant),callback:function ($$v) {_vm.tenant=$$v},expression:"tenant"}})
}
var staticRenderFns = []

export { render, staticRenderFns }